// extracted by mini-css-extract-plugin
export default {"container":"CustomerOrders_container__gKI8V"};